import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

interface Notification {
  id: string;
  userId: string;
  organizationId?: string;
  type: string;
  title: string;
  message: string;
  data?: any;
  read: boolean;
  createdAt: string;
}

interface NotificationsState {
  items: Notification[];
  unreadCount: number;
  connected: boolean;
}

const initialState: NotificationsState = {
  items: [],
  unreadCount: 0,
  connected: false
};

const notificationsSlice = createSlice({
  name: 'notifications',
  initialState,
  reducers: {
    addNotification: (state, action: PayloadAction<Notification>) => {
      // Add new notification to the beginning
      state.items.unshift(action.payload);
      
      // Increment unread count if not read
      if (!action.payload.read) {
        state.unreadCount += 1;
      }
    },
    setNotifications: (state, action: PayloadAction<Notification[]>) => {
      state.items = action.payload;
      state.unreadCount = action.payload.filter(n => !n.read).length;
    },
    markAsRead: (state, action: PayloadAction<string>) => {
      const notification = state.items.find(n => n.id === action.payload);
      if (notification && !notification.read) {
        notification.read = true;
        state.unreadCount -= 1;
      }
    },
    markAllAsRead: (state) => {
      state.items.forEach(notification => {
        notification.read = true;
      });
      state.unreadCount = 0;
    },
    clearAll: (state) => {
      state.items = [];
      state.unreadCount = 0;
    },
    setConnected: (state, action: PayloadAction<boolean>) => {
      state.connected = action.payload;
    }
  }
});

export const { 
  addNotification, 
  setNotifications,
  markAsRead, 
  markAllAsRead,
  clearAll,
  setConnected
} = notificationsSlice.actions;

export default notificationsSlice.reducer;
